import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../singleton/axios';

export interface DailyPERatioPoint {
  date: string;
  price: number;
  ttmEps: number;
  peRatio: number;
}

export interface PERatioHistoryResponse {
  data: DailyPERatioPoint[];
  ticker: string;
  years: number;
}

export const useCompanyPERatioHistory = (ticker: string, years: number) => {
  return useQuery<PERatioHistoryResponse, Error>({
    queryKey: ['companyPERatioHistory', ticker, years],
    queryFn: async () => {
      const { data } = await api.get<PERatioHistoryResponse>('/company-pe-ratio-history', {
        params: { ticker, years },
      });
      return data;
    },
    enabled: !!ticker,
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000, // 1 hour — matches API cache TTL
  });
};
